import * as React from 'react';

export const sgFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_339)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_339'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_339)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V12H0V0Z'
                    fill='#EE2436'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.00001 10.484C7.61334 10.604 7.20001 10.6667 6.76934 10.6667C4.50267 10.6667 2.66667 8.87601 2.66667 6.66667C2.66667 4.45734 4.50401 2.66667 6.76934 2.66667C7.19867 2.66667 7.61201 2.73067 8.00001 2.84934C6.33601 3.36001 5.12801 4.87601 5.12801 6.66667C5.12801 8.45734 6.33601 9.97334 8.00001 10.484ZM10.6667 4.00001H12V5.33334H10.6667V4.00001ZM13.3333 5.33334H14.6667V6.66667H13.3333V5.33334ZM12 8.00001H13.3333V9.33334H12V8.00001ZM8.00001 5.33334H9.33334V6.66667H8.00001V5.33334ZM9.33334 8.00001H10.6667V9.33334H9.33334V8.00001Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_339'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
